// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2d2da47f","667":"52426fbf","977":"0eb08fed"}[chunkId] + ".chunk.js";
};